"use client";

// src/components/QuantityStepper.tsx
import { IoAdd, IoRemove } from 'react-icons/io5';

type QuantityStepperProps = {
  quantity: number;
  onIncrease: () => void;
  onDecrease: () => void;
  className?: string;
};

const QuantityStepper = ({ quantity, onIncrease, onDecrease, className = '' }: QuantityStepperProps) => {
  return (
    <div className={`inline-flex h-10 w-[116px] items-center justify-between overflow-hidden rounded-full border border-gray-200 bg-white shadow-[0_1px_4px_rgba(15,23,42,0.05)] ${className}`}>
      <button
        onClick={onDecrease}
        className="flex h-full w-9 items-center justify-center text-gray-500 transition-colors hover:bg-gray-50 hover:text-accent active:bg-gray-100"
        aria-label="Decrease quantity"
      >
        <IoRemove size={14} />
      </button>
      <span className="min-w-8 text-center text-sm font-bold tabular-nums text-accent">{quantity}</span>
      <button
        onClick={onIncrease}
        className="flex h-full w-9 items-center justify-center text-gray-500 transition-colors hover:bg-orange-50 hover:text-primary active:bg-orange-100"
        aria-label="Increase quantity"
      >
        <IoAdd size={14} />
      </button>
    </div>
  );
};

export default QuantityStepper;
